import React, { forwardRef } from "react";
import MaskedInput from "react-text-mask";

interface CreditCardInputProps {
  [key: string]: any;
}

const CreditCardInput = forwardRef<HTMLInputElement, CreditCardInputProps>(
  function CreditCardInput(props, setRef) {
    return (
      <MaskedInput
        {...props}
        ref={(innerRef: any) => {
          // react-text-mask envuelve el <input> en un objeto → usamos inputElement
          if (innerRef && innerRef.inputElement) {
            if (typeof setRef === "function") {
              setRef(innerRef.inputElement);
            } else if (setRef) {
              setRef.current = innerRef.inputElement;
            }
          }
        }}
        mask={(rawValue: string = "") => {
          rawValue.replace(/\s/g, "");

          let mask = [
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            " ",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            " ",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            " ",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
          ];

          if (rawValue.length === 14)
            mask = [
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              " ",
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              " ",
              /\d/,
              /\d/,
              /\d/,
              /\d/,
            ];

          if (rawValue.length === 15)
            mask = [
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              " ",
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              " ",
              /\d/,
              /\d/,
              /\d/,
              /\d/,
              /\d/,
            ];

          return mask;
        }}
        placeholderChar={"\u2000"}
      />
    );
  }
);

export default CreditCardInput;
